export default __webpack_public_path__ + "static/media/news-act45.a35b0982.png";